import React, { lazy } from "react";
import { Route } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";

// Lazy load community components
const GroupsList = lazy(() =>
  import(
    "@/modules/communityGroups/features/GroupsList/components/GroupsList"
  ).then((module) => ({
    default: module.GroupsList,
  })),
);

const GroupDetail = lazy(() =>
  import(
    "@/modules/communityGroups/features/GroupDetail/components/GroupDetail"
  ).then((module) => ({
    default: module.GroupDetail,
  })),
);

// Create stable component reference
const HubMainLayout = () => <MainLayout section="hub" />;

/**
 * CommunityRoutes
 *
 * Routes for the Community Groups feature under /hub/community
 * All routes require authentication
 */
const CommunityRoutes = (
  <Route
    element={<AuthenticationGuard component={HubMainLayout} />}
    path="/hub/community"
  >
    <Route element={<GroupsList />} index />
    <Route element={<GroupDetail />} path="groups/:uuid" />
  </Route>
);

export default CommunityRoutes;
